/*
 * PasswordChanger Messages
 *
 * This contains all the text for the PasswordChanger component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.PasswordChanger";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the PasswordChanger component!",
  },
  oldPassword: {
    id: `${scope}.oldPassword`,
    defaultMessage: "Old password",
  },
  changePassword: {
    id: `${scope}.changePassword`,
    defaultMessage: "Change password",
  },
  passwordChangedSuccess: {
    id: `${scope}.passwordChangedSuccess`,
    defaultMessage: "Successfully changed password",
  },
});
